import bannerUrl from "./banner.jpg";
// import iconUrl from "./icons.jpg";

export const url =
  "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

const iconUrl = url;

export const NavBarData = [
  { image: url, Name: "Salon At Home" },
  { image: url, Name: "Pre Bridal & More" },
  { image: url, Name: "Deal of the Day" },
  { image: url, Name: "Make Up" },
  { image: url, Name: "Hair Salon" },
  { image: url, Name: "Your Product Our Services" },
  { image: url, Name: "Female Spa" },
];

export const BannerImages = [
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
  { image: bannerUrl },
];

export const features = [
  {
    heading: "Convenience",
    text: "Get high-quality beauty services in the comfort of your own home.",
  },
  {
    heading: "Saftey",
    text: "Reduce your risk of exposure to viruses of bacteria by avoiding crowded salons.",
  },
  {
    heading: "Quality",
    text: "Receive high-quality services from licensed and insured salon professionals.",
  },
  {
    heading: "Customization",
    text: "Communicate directly with your salon professional to receive a customized service that meets your specific needs.",
  },
];

export const faqData = [
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
  {
    title: "Why Choose SalonTym",
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, culpa pariatur fugiat fugit quo repudiandae veritatis quam unde ",
  },
];

export const iconsData = [
  { url: iconUrl, title: "Service @ Re.1" },
  { url: iconUrl, title: "Facial Sale" },
  { url: iconUrl, title: "Waxing Sale" },
  { url: iconUrl, title: "Make Your own package" },
  { url: iconUrl, title: "Summer Sale" },
  { url: iconUrl, title: "Month End Services" },
  { url: iconUrl, title: "Facial" },
  { url: iconUrl, title: "Waxing" },
  { url: iconUrl, title: "Manicure & Pedicure " },
  { url: iconUrl, title: "Threading" },
  { url: iconUrl, title: "D-Tan / Bleach" },
  { url: iconUrl, title: "Festive Season" },
  { url: iconUrl, title: "Routine Services" },
  { url: iconUrl, title: "Baby Doll" },
  { url: iconUrl, title: "Salary Day Services" },
  { url: iconUrl, title: "Body Polishing" },
  { url: iconUrl, title: "Be Relaxed" },
  { url: iconUrl, title: "End Season Sale" },
  { url: iconUrl, title: "Package You Love" },
  { url: iconUrl, title: "Rice Roll-On" },
  { url: iconUrl, title: "Let's Celebrate" },
];

const cardUrl =
  "https://media.istockphoto.com/id/1129638579/photo/calm-female-executive-meditating-taking-break-avoiding-stressful-job.jpg?s=2048x2048&w=is&k=20&c=5HODkWLipe7BO4T0gD5banuq42LdBndCiiwrn1fXvfk=";

export const SalonAtHomeServiceData = [
  {
    url: cardUrl,
    heading: "Bikni oihuh ",
    subHeading: "By conse yug etsy ",
    finalPrice: "458",
    discount: "1234",
    price: "2369",
    min: "250",
    serviceDetails: [
      { services: "1----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
      { services: "1----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
    ],
    descriptions: [
      {
        id: null,
        title: "WHY HEAD TO TOE SERVICES ARE IMPORTANT?",
        points: [
          "It helps your skin stay in good condition: You're shedding skin cells throughout the day, so it's important to keep your skin glowing and in good condition. An effective routine can help prevent acne, treat wrinkles, and help keep your skin looking its best.",
          "Minimizes dark spots. Skin bleaching treatments can reduce dark spots on the skin caused by sun damage, aging, and hormonal changes.",
          "Slowing down of hair re-growth.",
          "Remove sun tan.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "RECOMMENDED FOR",
        points: ["All Skin Types"],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "NOTE",
        points: [
          "Only mono sachet(One time use) Product will be handed over if left.",
          "Female Therapist to Female Client.",
          "It is highly appreciated if you could inform our representative within 24 to 48 hours about any service reaction then only our team will take the proper action.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "SALONTYM SUGGESTION",
        points: [
          "Inform the therapist if you are dealing with any pain or injury.",
          "Don't take meal or drink water at least 20 minuts before or after the massage.",
          "After waxing there would be possibility of getting skin redness/ hives/ inflammation, which subsides in few hours depending on skin to skin.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "WHY SALONTYM?",
        points: [
          "Skip the queue: With at-home salon services, you can skip the traffic as there is no waiting in a queue of customers or having others stand by",
          "0 compromise with quality - Unlike a crowded salon, it takes the time-limit pressure off from both the parties so that professionals can cater to your needs in a more relaxed manner, ensuring quality treatment and beauty services.",
          "Convenience: The in-house beauty treatment services are far more adaptable and you won't have to spend your day waiting. You can schedule the service anytime you want and the beautician will be at your door.",
          "Attention and Affordability: It saves you money that you would have spent commuting to the Salon otherwise. In the absence of other clients, your attendant gives you extra attention. At-home parlour services might cost you less and you can also ask the beautician to use your products.",
        ],
        sort: null,
        active: null,
      },
    ],
  },
  {
    url: cardUrl,
    heading: "Bikni oihuh ",
    subHeading: "By conse yug etsy ",
    finalPrice: "458",
    discount: "1234",
    min: "250",
    price: "2369",
    serviceDetails: [
      { services: "2----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
      { services: "2------ydg yu dugc yueyucftefd" },
    ],
    descriptions: [
      {
        id: null,
        title: "WHY HEAD TO TOE SERVICES ARE IMPORTANT?",
        points: [
          "It helps your skin stay in good condition: You're shedding skin cells throughout the day, so it's important to keep your skin glowing and in good condition. An effective routine can help prevent acne, treat wrinkles, and help keep your skin looking its best.",
          "Minimizes dark spots. Skin bleaching treatments can reduce dark spots on the skin caused by sun damage, aging, and hormonal changes.",
          "Slowing down of hair re-growth.",
          "Remove sun tan.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "RECOMMENDED FOR",
        points: ["All Skin Types"],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "NOTE",
        points: [
          "Only mono sachet(One time use) Product will be handed over if left.",
          "Female Therapist to Female Client.",
          "It is highly appreciated if you could inform our representative within 24 to 48 hours about any service reaction then only our team will take the proper action.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "SALONTYM SUGGESTION",
        points: [
          "Inform the therapist if you are dealing with any pain or injury.",
          "Don't take meal or drink water at least 20 minuts before or after the massage.",
          "After waxing there would be possibility of getting skin redness/ hives/ inflammation, which subsides in few hours depending on skin to skin.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "WHY SALONTYM?",
        points: [
          "Skip the queue: With at-home salon services, you can skip the traffic as there is no waiting in a queue of customers or having others stand by",
          "0 compromise with quality - Unlike a crowded salon, it takes the time-limit pressure off from both the parties so that professionals can cater to your needs in a more relaxed manner, ensuring quality treatment and beauty services.",
          "Convenience: The in-house beauty treatment services are far more adaptable and you won't have to spend your day waiting. You can schedule the service anytime you want and the beautician will be at your door.",
          "Attention and Affordability: It saves you money that you would have spent commuting to the Salon otherwise. In the absence of other clients, your attendant gives you extra attention. At-home parlour services might cost you less and you can also ask the beautician to use your products.",
        ],
        sort: null,
        active: null,
      },
    ],
  },
  {
    url: cardUrl,
    heading: "Bikni oihuh ",
    subHeading: "By conse yug etsy ",
    finalPrice: "458",
    discount: "1234",
    price: "2369",
    min: "250",

    serviceDetails: [
      { services: "3----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
      { services: "3------ydg yu dugc yueyucftefd" },
      { services: "3------ydg yu dugc yueyucftefd" },
    ],
    descriptions: [
      {
        id: null,
        title: "WHY HEAD TO TOE SERVICES ARE IMPORTANT?",
        points: [
          "It helps your skin stay in good condition: You're shedding skin cells throughout the day, so it's important to keep your skin glowing and in good condition. An effective routine can help prevent acne, treat wrinkles, and help keep your skin looking its best.",
          "Minimizes dark spots. Skin bleaching treatments can reduce dark spots on the skin caused by sun damage, aging, and hormonal changes.",
          "Slowing down of hair re-growth.",
          "Remove sun tan.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "RECOMMENDED FOR",
        points: ["All Skin Types"],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "NOTE",
        points: [
          "Only mono sachet(One time use) Product will be handed over if left.",
          "Female Therapist to Female Client.",
          "It is highly appreciated if you could inform our representative within 24 to 48 hours about any service reaction then only our team will take the proper action.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "SALONTYM SUGGESTION",
        points: [
          "Inform the therapist if you are dealing with any pain or injury.",
          "Don't take meal or drink water at least 20 minuts before or after the massage.",
          "After waxing there would be possibility of getting skin redness/ hives/ inflammation, which subsides in few hours depending on skin to skin.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "WHY SALONTYM?",
        points: [
          "Skip the queue: With at-home salon services, you can skip the traffic as there is no waiting in a queue of customers or having others stand by",
          "0 compromise with quality - Unlike a crowded salon, it takes the time-limit pressure off from both the parties so that professionals can cater to your needs in a more relaxed manner, ensuring quality treatment and beauty services.",
          "Convenience: The in-house beauty treatment services are far more adaptable and you won't have to spend your day waiting. You can schedule the service anytime you want and the beautician will be at your door.",
          "Attention and Affordability: It saves you money that you would have spent commuting to the Salon otherwise. In the absence of other clients, your attendant gives you extra attention. At-home parlour services might cost you less and you can also ask the beautician to use your products.",
        ],
        sort: null,
        active: null,
      },
    ],
  },
  {
    url: cardUrl,
    heading: "Bikni oihuh ",
    subHeading: "By conse yug etsy ",
    finalPrice: "458",
    discount: "1234",
    price: "2369",
    min: "250",

    serviceDetails: [
      { services: "1----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
      { services: "1----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
    ],
    descriptions: [
      {
        id: null,
        title: "WHY HEAD TO TOE SERVICES ARE IMPORTANT?",
        points: [
          "It helps your skin stay in good condition: You're shedding skin cells throughout the day, so it's important to keep your skin glowing and in good condition. An effective routine can help prevent acne, treat wrinkles, and help keep your skin looking its best.",
          "Minimizes dark spots. Skin bleaching treatments can reduce dark spots on the skin caused by sun damage, aging, and hormonal changes.",
          "Slowing down of hair re-growth.",
          "Remove sun tan.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "RECOMMENDED FOR",
        points: ["All Skin Types"],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "NOTE",
        points: [
          "Only mono sachet(One time use) Product will be handed over if left.",
          "Female Therapist to Female Client.",
          "It is highly appreciated if you could inform our representative within 24 to 48 hours about any service reaction then only our team will take the proper action.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "SALONTYM SUGGESTION",
        points: [
          "Inform the therapist if you are dealing with any pain or injury.",
          "Don't take meal or drink water at least 20 minuts before or after the massage.",
          "After waxing there would be possibility of getting skin redness/ hives/ inflammation, which subsides in few hours depending on skin to skin.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "WHY SALONTYM?",
        points: [
          "Skip the queue: With at-home salon services, you can skip the traffic as there is no waiting in a queue of customers or having others stand by",
          "0 compromise with quality - Unlike a crowded salon, it takes the time-limit pressure off from both the parties so that professionals can cater to your needs in a more relaxed manner, ensuring quality treatment and beauty services.",
          "Convenience: The in-house beauty treatment services are far more adaptable and you won't have to spend your day waiting. You can schedule the service anytime you want and the beautician will be at your door.",
          "Attention and Affordability: It saves you money that you would have spent commuting to the Salon otherwise. In the absence of other clients, your attendant gives you extra attention. At-home parlour services might cost you less and you can also ask the beautician to use your products.",
        ],
        sort: null,
        active: null,
      },
    ],
  },
  {
    url: cardUrl,
    heading: "Bikni oihuh ",
    subHeading: "By conse yug etsy ",
    finalPrice: "458",
    discount: "1234",
    price: "2369",
    min: "250",

    serviceDetails: [
      { services: "2----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
      { services: "2------ydg yu dugc yueyucftefd" },
    ],
    descriptions: [
      {
        id: null,
        title: "WHY HEAD TO TOE SERVICES ARE IMPORTANT?",
        points: [
          "It helps your skin stay in good condition: You're shedding skin cells throughout the day, so it's important to keep your skin glowing and in good condition. An effective routine can help prevent acne, treat wrinkles, and help keep your skin looking its best.",
          "Minimizes dark spots. Skin bleaching treatments can reduce dark spots on the skin caused by sun damage, aging, and hormonal changes.",
          "Slowing down of hair re-growth.",
          "Remove sun tan.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "RECOMMENDED FOR",
        points: ["All Skin Types"],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "NOTE",
        points: [
          "Only mono sachet(One time use) Product will be handed over if left.",
          "Female Therapist to Female Client.",
          "It is highly appreciated if you could inform our representative within 24 to 48 hours about any service reaction then only our team will take the proper action.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "SALONTYM SUGGESTION",
        points: [
          "Inform the therapist if you are dealing with any pain or injury.",
          "Don't take meal or drink water at least 20 minuts before or after the massage.",
          "After waxing there would be possibility of getting skin redness/ hives/ inflammation, which subsides in few hours depending on skin to skin.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "WHY SALONTYM?",
        points: [
          "Skip the queue: With at-home salon services, you can skip the traffic as there is no waiting in a queue of customers or having others stand by",
          "0 compromise with quality - Unlike a crowded salon, it takes the time-limit pressure off from both the parties so that professionals can cater to your needs in a more relaxed manner, ensuring quality treatment and beauty services.",
          "Convenience: The in-house beauty treatment services are far more adaptable and you won't have to spend your day waiting. You can schedule the service anytime you want and the beautician will be at your door.",
          "Attention and Affordability: It saves you money that you would have spent commuting to the Salon otherwise. In the absence of other clients, your attendant gives you extra attention. At-home parlour services might cost you less and you can also ask the beautician to use your products.",
        ],
        sort: null,
        active: null,
      },
    ],
  },
  {
    url: cardUrl,
    heading: "Bikni oihuh ",
    subHeading: "By conse yug etsy ",
    finalPrice: "458",
    discount: "1234",
    price: "2369",
    min: "250",

    serviceDetails: [
      { services: "3----yudftyf tfdtyqf tftyqfqdtyftyqwfdt yqwcdtyqw" },
      { services: "3------ydg yu dugc yueyucftefd" },
      { services: "3------ydg yu dugc yueyucftefd" },
    ],
    descriptions: [
      {
        id: null,
        title: "WHY HEAD TO TOE SERVICES ARE IMPORTANT?",
        points: [
          "It helps your skin stay in good condition: You're shedding skin cells throughout the day, so it's important to keep your skin glowing and in good condition. An effective routine can help prevent acne, treat wrinkles, and help keep your skin looking its best.",
          "Minimizes dark spots. Skin bleaching treatments can reduce dark spots on the skin caused by sun damage, aging, and hormonal changes.",
          "Slowing down of hair re-growth.",
          "Remove sun tan.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "RECOMMENDED FOR",
        points: ["All Skin Types"],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "NOTE",
        points: [
          "Only mono sachet(One time use) Product will be handed over if left.",
          "Female Therapist to Female Client.",
          "It is highly appreciated if you could inform our representative within 24 to 48 hours about any service reaction then only our team will take the proper action.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "SALONTYM SUGGESTION",
        points: [
          "Inform the therapist if you are dealing with any pain or injury.",
          "Don't take meal or drink water at least 20 minuts before or after the massage.",
          "After waxing there would be possibility of getting skin redness/ hives/ inflammation, which subsides in few hours depending on skin to skin.",
        ],
        sort: null,
        active: null,
      },
      {
        id: null,
        title: "WHY SALONTYM?",
        points: [
          "Skip the queue: With at-home salon services, you can skip the traffic as there is no waiting in a queue of customers or having others stand by",
          "0 compromise with quality - Unlike a crowded salon, it takes the time-limit pressure off from both the parties so that professionals can cater to your needs in a more relaxed manner, ensuring quality treatment and beauty services.",
          "Convenience: The in-house beauty treatment services are far more adaptable and you won't have to spend your day waiting. You can schedule the service anytime you want and the beautician will be at your door.",
          "Attention and Affordability: It saves you money that you would have spent commuting to the Salon otherwise. In the absence of other clients, your attendant gives you extra attention. At-home parlour services might cost you less and you can also ask the beautician to use your products.",
        ],
        sort: null,
        active: null,
      },
    ],
  },
];

export const AppointmentData = {
  cancelled: [],
  completed: [],
  ongoing: [],
};

export const Campaigns = [
  { heading: "Referral Network" },
  { heading: "MultiLevel Network" },
];

export const ChallengeBoardData = [
  {
    heading: "Referral Network",
    imageUrl: iconUrl,
    Coins: "100",
    heading: "Welcome",
    subHeading: "",
  },
  {
    heading: "Referral Network",
    imageUrl: iconUrl,
    Coins: "300",
    heading: "1st Referral Order",
    subHeading: "1 left",
  },
  {
    heading: "Referral Network",
    imageUrl: iconUrl,
    Coins: "300",
    heading: "Welcome",
    subHeading: "1 left",
  },
  {
    heading: "Referral Network",
    imageUrl: iconUrl,
    Coins: "1000",
    heading: "Welcome",
    subHeading: "1 left",
  },
  {
    heading: "Referral Network",
    imageUrl: iconUrl,
    Coins: "200",
    heading: "First Reveral",
    subHeading: "1 left",
  },
  {
    heading: "Referral Network",
    imageUrl: iconUrl,
    Coins: "800",
    heading: "Welcome",
    subHeading: "1 left",
  },
];

export const TeamsData = {
  managment: [
    {
      Name: "Vishal Saini",
      imageUrl: iconUrl,
      position: "CTO & Co-Fouder",
      Contact: "8510000223",
      Email: "vishal@salontym.com",
    },
    {
      Name: "Geeta Chetri",
      imageUrl: iconUrl,
      position: "CEO & Co-Founder",
      Contact: "8510000223",
      Email: "geeta@salontym.com",
    },
  ],

  hr: [
    {
      Name: "Ankita Dubey",
      imageUrl: iconUrl,
      position: "Senior HR",
      Contact: "8510000223",
      Email: "hr@salontym.com",
    },
    {
      Name: "Anshika Varshney",
      imageUrl: iconUrl,
      position: "Recruiter",
      Contact: "8510000223",
      Email: "career@salontym.com",
    },
  ],

  customerSupport: [
    {
      Name: "Anuradha Sharma",
      imageUrl: iconUrl,
      position: "Team Lead",
      Contact: "8510000223",
      Email: "support@salontym.com",
    },
    {
      Name: "Priya Kumari",
      imageUrl: iconUrl,
      position: "Executive",
      Contact: "8510000223",
      Email: "support@salontym.com",
    },
    {
      Name: "Neha Mishra",
      imageUrl: iconUrl,
      position: "Executive",
      Contact: "8510000223",
      Email: "support@salontym.com",
    },
    {
      Name: "Shivani Pal",
      imageUrl: iconUrl,
      position: "Executive",
      Contact: "8510000223",
      Email: "support@salontym.com",
    },
    {
      Name: "Gulafsha",
      imageUrl: iconUrl,
      position: "Executive",
      Contact: "8510000223",
      Email: "support@salontym.com",
    },
  ],

  delivery: [
    {
      Name: "Vimal Notiyal",
      imageUrl: iconUrl,
      position: "Team Lead",
      Contact: "7827359668",
      Email: "support@salontym.com",
    },
  ],

  partnerHiring: [
    {
      Name: "Sanju Kumari",
      imageUrl: iconUrl,
      position: "Executive",
      Contact: "8510000223",
      Email: "support@salontym.com",
    },
    {
      Name: "Priya Rajput",
      imageUrl: iconUrl,
      position: "Executive",
      Contact: "8510000223",
      Email: "support@salontym.com",
    },
  ],

  Traning: [
    {
      Name: "Krishna",
      imageUrl: iconUrl,
      position: "Senior Trainer",
      Contact: "8510000223",
      Email: "training@salontym.com",
    },
    {
      Name: "Sanju Kumari",
      imageUrl: iconUrl,
      position: "Executive",
      Contact: "8510000223",
      Email: "training@salontym.com",
    },
  ],

  ProductManager: [
    {
      Name: "Nishu Saini",
      imageUrl: iconUrl,
      position: "Manager",
      Contact: "8510000223",
      Email: "product@salontym.com",
    },
  ],

  franchise: [
    {
      Name: "Amit Nigam",
      imageUrl: iconUrl,
      position: "Manager",
      Contact: "8595086948",
      Email: "franchise@salontym.com",
    },
  ],

  development: [
    {
      Name: "Pankaj Kumar",
      imageUrl: iconUrl,
      position: "Software Developer",
      Contact: "8384064378",
      Email: "pankaj.kumar@salontym.com",
    },
    {
      Name: "Graphic",
      imageUrl: iconUrl,
      position: "Caller",
      Contact: "84597618545",
      Email: "test@gmail.com",
    },
  ],
};

export const EarnCoinData = [
  {
    heading: "How to earn Salontym Coins?",
    subHeading: [
      "Refer your friends and build your referral network to earn more coins.",
      "Complete challenges provided by Salontym to earn coins.",
      "Participate in Salontym campaigns to earn more coins.",
      "Avail the Salon at Home services from Salontym to get cashback Salontym Coins.",
    ],
  },
  {
    heading: "How to use Salontym Coins?",
    subHeading: [
      "Salontym Coin is a currency that can be used to buy a wide range of branded products and services at Salontym Store without any monetary payment required.",
      "It's a hassle-free way to access all of Salontym's offerings without any restrictions on redeeming your coins.",
      "So, you can enjoy a seamless shopping experience and make the most of Salontym's products and services using Salontym Coin.",
    ],
  },
  {
    heading: "How many branded products does Salontym have in their store?",
    subHeading: [
      "Salontym Store offers a variety of top-quality branded products, including Lakme L'Oreal Professional, MAC, Maybelline, and Colorbar.",
      "With Salontym Coin, you can purchase any of these premium brands without having to pay any money.",
      "So, whether you're looking for makeup, haircare, or skincare products, Salontym Store has got you covered with its impressive range of branded items.",
      "Enjoy a hassle-free shopping experience and get access to the best products with Salontym Coin.",
    ],
  },
];
